export const AccessTokenModalType = {
	ADD_NEW_TOKEN: 'addNewToken',
	EDIT_TOKEN: 'editToken',
	EXPIRED_TOKEN: 'expiredToken',
} as const;

export type AccessTokenModalType = (typeof AccessTokenModalType)[keyof typeof AccessTokenModalType];

export const ACCESS_TOKEN_VALID = 'VALID';
export const ACCESS_TOKEN_EXPIRING = 'EXPIRING';
export const ACCESS_TOKEN_NOT_FOUND = 'NOT_FOUND';
